import { render, staticRenderFns } from "./CobranzaDelete.vue?vue&type=template&id=7543a224"
import script from "./CobranzaDelete.vue?vue&type=script&lang=js"
export * from "./CobranzaDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports